import * as React from "react";
import "highlight.js/styles/base16/harmonic16-dark.css";
import hljs from "highlight.js";
import {Control, Field, Icon, Label, Select} from "bloomer";
import {getAPIKeys} from "../../../utils/auth";
import {loadCodeSamples} from "../../../api/models/ModelInfo";
import CodeExample from "./CodeExample";
import Spacer from "../../../elements/Spacer";
import styled from "react-emotion";

const APIKeyControl = styled(Control)`
  display: inline-block;
`;

const APIKeyLabel = styled(Label)`
  display: inline-block;
  vertical-align: bottom;
  text-align: right;
  margin-right: 10px;
`;

interface ICodeExampleProps {
    modelName: string;
    language: string;
    codeClass: string;
}

interface ICodeExampleState {
    loading: boolean;
    apiKeys: any;
    codeExamples: any;
    selectedAPIKey: string;
    selectedAPIKeyValue: string;
}

class CodeExamples extends React.Component<ICodeExampleProps, ICodeExampleState> {
    public USER_API_KEY = "your-api-key";

    constructor(props: ICodeExampleProps) {
        super(props);

        this.state = {
            loading: false,
            apiKeys: [],
            codeExamples: [],
            selectedAPIKey: "",
            selectedAPIKeyValue: ""
        };
    }

    public async componentDidMount() {
        await this.loadAPIKeys();
        await this.loadCodeSamples();
    }

    public loadAPIKeys = async () => {
        const apiKeys = await getAPIKeys();
        if (apiKeys) {
            this.setState({
                apiKeys
            });
        }
    };

    public loadCodeSamples = async () => {
        this.setState({
            loading: true
        });
        let errorOccurred = false;
        const codeExamples = await loadCodeSamples(this.props.modelName, this.props.language).catch((error) => {
            errorOccurred = true;
        });
        if (errorOccurred) {
            this.setState({
                loading: false
            });
            return;
        }
        if (codeExamples) {
            let selectedAPIKey = "";
            let selectedAPIKeyValue = "";
            if (this.state.apiKeys && this.state.apiKeys[0]) {
                const apiKey = this.state.apiKeys[0];
                selectedAPIKey = apiKey.id;
                selectedAPIKeyValue = apiKey.api_key;
            }

            if (selectedAPIKeyValue) {
                codeExamples.forEach((ce: any) => {
                    if (ce.code) {
                        ce.usageCodeOriginal = ce.code;
                        ce.code = ce.usageCodeOriginal.replace(this.USER_API_KEY, selectedAPIKeyValue);
                    }
                });
            }

            this.setState({
                loading: false,
                selectedAPIKey,
                selectedAPIKeyValue,
                codeExamples
            }, () => {
                if (hljs) {
                    hljs.highlightAll();
                }
            });
        }
    };

    public handleAPIKeyChange = (e: any) => {
        const id = e.target.value;
        let apiKey = "";
        const found = this.state.apiKeys.find((a: any) => a.id.toString() === id.toString());
        if (found) {
            apiKey = found.api_key;
        }
        this.setState({
            selectedAPIKey: id,
            selectedAPIKeyValue: apiKey
        }, () => {
            if (apiKey) {
                const codeExamples = this.state.codeExamples;
                codeExamples.forEach((ce: any) => {
                    if (ce.usageCodeOriginal) {
                        ce.code = ce.usageCodeOriginal.replace(this.USER_API_KEY, apiKey);
                    }
                });
                this.setState({
                    codeExamples
                }, () => {
                    if (hljs) {
                        hljs.highlightAll();
                    }
                });
            }
        });
    };

    public render() {
        if (this.state.loading) {
            return <div style={{textAlign: 'center'}}>
                <span>Loading...</span>
                <Icon className="fas fa-spinner fa-spin"/>
            </div>;
        }

        return <React.Fragment>
            {
                this.state.codeExamples.length > 0 ? <div style={{ display: "flex" }}>
                    <div style={{ flex: 1 }}>
                        <Field style={{float: 'left', display: "inline-block"}}>
                            <APIKeyLabel>API Key:</APIKeyLabel>
                            <APIKeyControl>
                                <Select style={{width: '300px'}} onChange={this.handleAPIKeyChange} value={this.state.selectedAPIKey}>
                                    {
                                        this.state.apiKeys.map((apiKey: any) => {
                                            return <option key={apiKey.id} value={apiKey.id}>{apiKey.name}</option>;
                                        })
                                    }
                                </Select>
                            </APIKeyControl>
                        </Field>
                    </div>
                </div> : <></>
            }
            <Spacer/>
            {
                this.state.codeExamples.map((c: any, index: number) => {
                    return <React.Fragment key={index}>
                        <CodeExample
                            modelName={this.props.modelName}
                            language={this.props.language}
                            codeClass={this.props.codeClass}
                            inputCode={c.input}
                            outputCode={c.output}
                            usageCode={c.code}
                            title={c.name}
                        />
                        <Spacer/>
                    </React.Fragment>;
                })
            }
        </React.Fragment>;
    }
}

export default CodeExamples;


// WEBPACK FOOTER //
// ./src/components/model/APIDocs/CodeExamples.tsx